import { AnyAction } from 'redux';
import { ApplicationState, WithScope } from '@mews-commander/types';
import { LazyLoadable } from '@mews-commander/ui';
import { NewReservationScreenUrlParams } from './schemas/urlParamsSchema';

interface Props extends WithScope {
    searchParams: NewReservationScreenUrlParams;
}

interface Exports {
    NewReservation: {
        NewReservation: React.FC<Props>;
        reducer: (state: ApplicationState, action: AnyAction) => ApplicationState;
        MODULE_NAME: string;
    };
}

export const NewReservation = LazyLoadable<Props, Exports, $TSFixMe>({
    loader: {
        // eslint-disable-next-line @typescript-eslint/require-await
        NewReservation: async () => import(/* webpackChunkName: "NewReservation" */ '.') as $TSFixMe,
    },
    extraProps: {} as { scope: string },
    render: (loaded, { injectReducer, scope, dispatch, getState, ...other }) => {
        const {
            NewReservation: LoadedNewReservation,
            reducer: newReservationReducer,
            MODULE_NAME: newReservationModuleName,
        } = loaded.NewReservation;
        injectReducer(newReservationModuleName, newReservationReducer);
        return <LoadedNewReservation {...other} scope={scope} />;
    },
});
